import { HOMEPAGE_RECOMMENDATIONS as R } from "../../data/content";
import { Reveal } from "../MaskedLine";

// Words exactly as written by the recommenders — do not edit quotes.
export default function Recommendations() {
  return (
    <section data-testid="recommendations-section" className="ground-lab sec-pad border-t border-[color:var(--line-soft)]">
      <div className="wrap">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <p className="stamp mb-4" style={{ fontSize: 12 }}>Recommendations</p>
            <h2 className="h-section" style={{ fontSize: "clamp(28px, 3.4vw, 46px)", lineHeight: 1.08 }}>
              In their <span className="claim">words.</span>
            </h2>
          </div>
          <p className="font-body-serif measure-narrow text-[#383D5A]" style={{ fontSize: 17 }}>
            Written by professionals who have been in the room. Unedited.
          </p>
        </div>

        {/* Featured recommendation */}
        <Reveal>
          <figure className="border-t-[1.5px] border-[color:var(--ink)] pt-10 md:pt-14" data-testid="recommendation-featured">
            <blockquote className="font-aside max-w-[1000px]" style={{ fontSize: "clamp(24px, 3vw, 42px)", lineHeight: 1.28 }}>
              &ldquo;{R.featured.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-8 flex flex-wrap items-center gap-x-4 gap-y-2">
              <span className="series-stamp"><span>{R.featured.name}</span></span>
              <span className="stamp-dim">{R.featured.role} · {R.featured.org}</span>
            </figcaption>
          </figure>
        </Reveal>

        {/* Supporting recommendations */}
        <div className="grid grid-cols-1 md:grid-cols-3 mt-14 border-t-[1.5px] border-[color:var(--ink)]">
          {R.supporting.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.05}>
              <figure
                data-testid={`recommendation-card-${i}`}
                className={`p-8 md:p-10 h-full border-b-[1.5px] border-[color:var(--ink)] md:border-b-0 ${i > 0 ? "md:border-l-[1.5px]" : ""}`}
              >
                <blockquote className="font-body-serif" style={{ fontSize: 17, lineHeight: 1.65 }}>
                  &ldquo;{r.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-6">
                  <p className="stamp" style={{ fontSize: 12 }}>{r.name}</p>
                  <p className="stamp-dim mt-2">{r.role} · {r.org}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        {/* Further recommendations — quieter row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-10 mt-12 pt-10 border-t border-[color:var(--line-soft)]">
          {R.more.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.05}>
              <figure data-testid={`recommendation-more-${i}`} className="flex flex-col h-full">
                <blockquote className="font-body-serif text-[#383D5A]" style={{ fontSize: 15.5, lineHeight: 1.65 }}>
                  &ldquo;{r.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-4">
                  <span className="stamp" style={{ fontSize: 11 }}>{r.name}</span>
                  <span className="stamp-dim ml-3">{r.role} · {r.org}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
